import React from "react";
import { classNames } from "../../helpers/classNames";

const Checkbox = ({
  checkboxName,
  checkboxInputClass,
  isChecked,
  checkboxClass,
  checkboxLabel,
  checkboxLableClass,
  strike = false,
  checked,
  divClass,
  isDisabled,
  onChange = () => { },
  ...props
}) => {
  return (
    <>
      <div
        className={classNames(
          "relative overflow-hidden flex flex-shrink-0 ",
          divClass
        )}
      >
        <input
          type="checkbox"
          name={checkboxName}
          className={classNames(
            "peer absolute top-0 left-0 w-5 h-5 opacity-0 z-10",
            checkboxInputClass,
            isDisabled ? "cursor-not-allowed" : " cursor-pointer"
          )}
          defaultChecked={isChecked}
          checked={checked}
          onChange={onChange}
          isDisabled={isDisabled}
        />
        <div
          className={classNames(
            "w-5 h-5 min-w-[20px] border border-slate-300 dark:border-slate-600 rounded flex items-center justify-center text-sm text-black/0",
            checkboxClass,
            isDisabled
              ? "cursor-not-allowed bg-slate-200 dark:bg-slate-800 peer-checked:bg-slate-400 dark:peer-checked:bg-slate-700 peer-checked:border-slate-400 dark:peer-checked:border-slate-600 peer-checked:text-white dark:peer-checked:text-slate-500"
              : " bg-white dark:bg-slate-700 peer-checked:bg-orange-500 peer-checked:border-orange-500 peer-checked:text-white"
          )}
        >
          <i className="fa-light fa-check"></i>
        </div>
        {checkboxLabel && (
          <div
            className={classNames(
              "text-sm text-slate-500 w-full ml-3 transition-all duration-200",
              strike ? "peer-checked:line-through" : "",
              checkboxLableClass,
              isDisabled ? "opacity-50" : ""
            )}
          >
            {checkboxLabel}
          </div>
        )}
      </div>
    </>
  );
};

export default Checkbox;
